export type MediaType = "movie" | "tv" | "variety";

export interface Media {
  id: string;
  title: string;
  type: MediaType;
  genres: string[];
  region: string;
  year: number;
  duration: string;
  episodes: string;
  director: string;
  cast: string[];
  rating: number;
  views: number;
  updatedAt: string;
  cover: string;
  banner?: string;
  summary: string;
  status: string;
}

export const typeLabel: Record<MediaType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const mediaList: Media[] = [
  {
    id: "fog-city-rain",
    title: "雾城雨季",
    type: "movie",
    genres: ["悬疑", "剧情"],
    region: "国产",
    year: 2026,
    duration: "127分钟",
    episodes: "完整版",
    director: "陆知远",
    cast: ["林砚白", "沈翊", "周清和", "许若菁"],
    rating: 8.9,
    views: 1286000,
    updatedAt: "2026-10-12",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20movie%20poster%20of%20a%20rainy%20old%20southern%20Chinese%20city%20alley%20at%20dusk%2C%20a%20lone%20figure%20with%20an%20umbrella%20silhouetted%20against%20warm%20amber%20streetlamp%20glow%2C%20soft%20teal%20and%20muted%20navy%20tones%2C%20mist%20and%20reflective%20wet%20stone%20ground%2C%20moody%20film%20noir%20lighting%2C%20mystery%20thriller%20aesthetic%2C%20elegant%20fine%20grain&width=600&height=840&seq=mv-fog-city-rain&orientation=portrait",
    summary:
      "一场持续四十三天的雨，让临江城连续出现三起无人目击的失踪案。退休法医程墨在一本旧病历里发现了同一个名字，牵着一条谁都不愿提起的往事。当雾散去，真相却比雨夜更难看清。",
  },
  {
    id: "seventh-tide",
    title: "第七次潮汐",
    type: "movie",
    genres: ["科幻", "爱情"],
    region: "国产",
    year: 2026,
    duration: "134分钟",
    episodes: "完整版",
    director: "陶行之",
    cast: ["顾南星", "谢清扬", "安如", "陈岱"],
    rating: 9.1,
    views: 2043000,
    updatedAt: "2026-10-15",
    status: "独家上线",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20romance%20movie%20poster%2C%20a%20luminous%20enormous%20tide%20wave%20frozen%20in%20the%20sky%20above%20a%20quiet%20coastal%20town%2C%20two%20small%20figures%20standing%20on%20a%20pier%20facing%20the%20glowing%20horizon%2C%20deep%20navy%20and%20soft%20amber%20color%20grading%2C%20stars%20reflected%20on%20still%20water%2C%20dreamlike%20ethereal%20atmosphere%2C%20high%20detail%20editorial%20key%20art&width=600&height=840&seq=mv-seventh-tide&orientation=portrait",
    summary:
      "海边的观潮站每年重复同一天。气象员沈知微在第七次循环里，遇见了一个从未出现在记录中的男人。他们只有潮水上涨前的一小时，去改写一件早已发生的事。",
  },
  {
    id: "steel-and-plum",
    title: "钢与梅",
    type: "movie",
    genres: ["动作", "历史"],
    region: "国产",
    year: 2025,
    duration: "142分钟",
    episodes: "完整版",
    director: "罗定山",
    cast: ["秦子铭", "白婉", "霍沉", "苏怀"],
    rating: 8.4,
    views: 1748000,
    updatedAt: "2026-09-28",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Epic%20martial%20arts%20historical%20film%20poster%2C%20a%20solemn%20swordsman%20in%20dark%20steel%20armor%20standing%20in%20falling%20snow%20before%20a%20blooming%20white%20plum%20tree%2C%20cold%20charcoal%20background%20with%20warm%20crimson%20accent%20light%2C%20ink%20painting%20texture%2C%20dramatic%20side%20lighting%2C%20cinematic%20poster%20composition%2C%20refined%20eastern%20aesthetic&width=600&height=840&seq=mv-steel-and-plum&orientation=portrait",
    summary:
      "北境铁匠的女儿在灭门之夜握起了父亲未完成的刀。十年后，她用这把刀走回了那座烧毁她家的城，却发现仇人的名字刻在守城阵亡将士碑上。",
  },
  {
    id: "midnight-diner",
    title: "凌晨三点的面馆",
    type: "movie",
    genres: ["剧情", "治愈"],
    region: "国产",
    year: 2025,
    duration: "112分钟",
    episodes: "完整版",
    director: "何晚晴",
    cast: ["孟川", "李桃", "沈星野", "郭小满"],
    rating: 8.7,
    views: 986000,
    updatedAt: "2026-09-16",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cozy%20film%20poster%20of%20a%20tiny%20late%20night%20noodle%20shop%20on%20an%20empty%20city%20street%2C%20steaming%20bowls%20under%20a%20single%20paper%20lantern%2C%20deep%20teal%20night%20outside%20and%20honey%20amber%20interior%20light%2C%20rain%20slicked%20pavement%20reflections%2C%20gentle%20healing%20slice%20of%20life%20atmosphere%2C%20cinematic%20composition&width=600&height=840&seq=mv-midnight-diner&orientation=portrait",
    summary:
      "一家只在凌晨三点开门的面馆，老板从不问客人的名字。六个失眠的夜晚，六段被温热汤面接住的人生，最后连他自己也坐到了吧台前。",
  },
  {
    id: "orbit-eleven",
    title: "轨道十一号",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "欧美",
    year: 2026,
    duration: "148分钟",
    episodes: "完整版",
    director: "Elias Vance",
    cast: ["Marcus Hale", "Nora Quinn", "Ivan Petrov", "Leah Sanders"],
    rating: 8.6,
    views: 2560000,
    updatedAt: "2026-10-08",
    status: "4K 修复",
    cover: "https://readdy.ai/api/search-image?query=Space%20survival%20sci-fi%20movie%20poster%2C%20a%20weathered%20single%20astronaut%20helmet%20reflecting%20a%20distant%20burning%20space%20station%2C%20deep%20midnight%20blue%20void%20with%20scattered%20stars%2C%20orange%20emergency%20light%20streaks%2C%20ultra%20detailed%20metal%20textures%2C%20cinematic%20dramatic%20composition%2C%20premium%20key%20art&width=600&height=840&seq=mv-orbit-eleven&orientation=portrait",
    summary:
      "十一号轨道站的补给船失联后，仅剩的两名宇航员必须在氧气耗尽前完成一次无人尝试过的对接。而站内日志显示，第三个乘员的名字从未被删除。",
  },
  {
    id: "letters-from-harbor",
    title: "港口来信",
    type: "movie",
    genres: ["爱情", "剧情"],
    region: "欧美",
    year: 2025,
    duration: "118分钟",
    episodes: "完整版",
    director: "Clara Lindqvist",
    cast: ["Jonas Berg", "Amelia Fry", "Ruth Vale", "Peter Lund"],
    rating: 8.2,
    views: 1120000,
    updatedAt: "2026-08-30",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20poster%20of%20an%20old%20northern%20harbor%20pier%20at%20blue%20hour%2C%20a%20woman%20in%20a%20long%20wool%20coat%20holding%20a%20letter%2C%20muted%20slate%20blue%20sea%20and%20pale%20peach%20sky%2C%20string%20lights%20on%20wooden%20boats%2C%20nostalgic%20quiet%20melancholy%20tone%2C%20film%20grain%2C%20elegant%20minimal%20composition&width=600&height=840&seq=mv-letters-harbor&orientation=portrait",
    summary:
      "一封寄错地址的信，让两个从未见过面的人通信了七年。当港口终于迎来同一天的同一场雪，他们必须在信里写下最后一次见面约定。",
  },
  {
    id: "the-last-bell",
    title: "最后一节课",
    type: "movie",
    genres: ["剧情", "青春"],
    region: "日韩",
    year: 2025,
    duration: "108分钟",
    episodes: "完整版",
    director: "佐藤和也",
    cast: ["小林悠真", "宫崎铃", "中村丈", "川岛澪"],
    rating: 8.5,
    views: 874000,
    updatedAt: "2026-08-22",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20youth%20drama%20film%20poster%2C%20empty%20high%20school%20classroom%20at%20sunset%2C%20chalk%20writing%20on%20a%20green%20blackboard%2C%20warm%20golden%20afternoon%20light%20through%20half%20open%20windows%2C%20curtain%20moving%20in%20the%20breeze%2C%20soft%20dust%20motes%20in%20the%20air%2C%20nostalgic%20gentle%20bittersweet%20mood%2C%20cinematic%20portrait%20poster&width=600&height=840&seq=mv-the-last-bell&orientation=portrait",
    summary:
      "即将拆除的旧校舍，只留下最后一名学生和一位准备退休的老师。他们决定把那节从未上完的课，上到毕业铃声响起为止。",
  },
  {
    id: "night-market-kings",
    title: "夜市之王",
    type: "movie",
    genres: ["喜剧", "美食"],
    region: "国产",
    year: 2026,
    duration: "104分钟",
    episodes: "完整版",
    director: "史大鹏",
    cast: ["马骁", "黄一鸣", "温小柔", "戴北辰"],
    rating: 7.9,
    views: 1432000,
    updatedAt: "2026-10-05",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20comedy%20food%20movie%20poster%2C%20a%20crowded%20Asian%20night%20market%20street%20with%20steaming%20woks%20and%20glowing%20red%20lanterns%2C%20smoke%20and%20warm%20orange%20light%2C%20a%20confident%20chef%20mid%20flip%20of%20a%20pan%2C%20teal%20night%20sky%20above%2C%20energetic%20festive%20atmosphere%2C%20rich%20saturated%20cinematic%20detail&width=600&height=840&seq=mv-night-market-kings&orientation=portrait",
    summary:
      "城中村夜市即将被改造，一条街的摊主推出最不像样的代表去参加美食大赛。他炒的每一盘菜都难吃，但每一盘菜背后都有一个故事。",
  },
  {
    id: "frozen-border",
    title: "冰原边界",
    type: "movie",
    genres: ["动作", "犯罪"],
    region: "欧美",
    year: 2024,
    duration: "131分钟",
    episodes: "完整版",
    director: "Dmitri Sokolov",
    cast: ["Viktor Lang", "Ilona Marsh", "Tobias Reed", "Mia Novak"],
    rating: 8.0,
    views: 1650000,
    updatedAt: "2026-07-19",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Gritty%20action%20thriller%20poster%2C%20a%20lone%20figure%20in%20a%20heavy%20parka%20walking%20across%20a%20vast%20frozen%20snow%20plain%20at%20twilight%2C%20faint%20orange%20headlights%20in%20the%20distant%20fog%2C%20cold%20steel%20blue%20palette%20with%20warm%20accent%2C%20harsh%20wind%20blown%20snow%20texture%2C%20stark%20cinematic%20composition&width=600&height=840&seq=mv-frozen-border&orientation=portrait",
    summary:
      "边境检查站的最后一夜，一名报关员发现列车上多了一个不在名单上的人。暴风雪封路的八小时里，他必须在职责和直觉之间选一次。",
  },
  {
    id: "paper-moon-club",
    title: "纸月亮俱乐部",
    type: "movie",
    genres: ["喜剧", "剧情"],
    region: "国产",
    year: 2025,
    duration: "116分钟",
    episodes: "完整版",
    director: "苏晚",
    cast: ["唐宁", "关山月", "谢小满", "罗启年"],
    rating: 8.3,
    views: 723000,
    updatedAt: "2026-07-02",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20indie%20drama%20poster%2C%20an%20old%20community%20theatre%20stage%20with%20a%20huge%20paper%20moon%20prop%20hanging%20above%2C%20warm%20mustard%20and%20dusty%20magenta%20stage%20lights%2C%20silhouettes%20of%20four%20actors%20rehearsing%2C%20velvet%20curtain%20texture%2C%20nostalgic%20charming%20tone%2C%20cinematic%20still&width=600&height=840&seq=mv-paper-moon-club&orientation=portrait",
    summary:
      "一个只有十一张椅子的社区小剧场，五个平均年龄六十二岁的老人，决定排一部关于自己年轻时代的戏。观众不多，但他们排练得很认真。",
  },
  {
    id: "deep-sea-signal",
    title: "深海信号",
    type: "movie",
    genres: ["悬疑", "科幻"],
    region: "日韩",
    year: 2026,
    duration: "124分钟",
    episodes: "完整版",
    director: "金泰浩",
    cast: ["李泰成", "朴秀妍", "郑在民", "崔恩书"],
    rating: 8.8,
    views: 1893000,
    updatedAt: "2026-10-14",
    status: "独家上线",
    cover: "https://readdy.ai/api/search-image?query=Underwater%20mystery%20sci-fi%20movie%20poster%2C%20a%20deep%20sea%20research%20submersible%20with%20a%20single%20searchlight%20beam%20illuminating%20a%20vast%20dark%20trench%2C%20tiny%20glowing%20particles%20suspended%20in%20water%2C%20faint%20teal%20and%20amber%20highlights%2C%20oppressive%20claustrophobic%20deep%20ocean%20atmosphere%2C%20ultra%20detailed%20cinematic%20key%20art&width=600&height=840&seq=mv-deep-sea-signal&orientation=portrait",
    summary:
      "海沟四千米处，深海科考队收到一段规律的敲击声。声纹分析显示，它的节奏来自一艘三十年前就已沉没的科考船。",
  },
  {
    id: "summer-of-cicadas",
    title: "蝉鸣之夏",
    type: "movie",
    genres: ["青春", "爱情"],
    region: "日韩",
    year: 2024,
    duration: "106分钟",
    episodes: "完整版",
    director: "森田凉",
    cast: ["高桥葵", "石井航", "远藤梨", "前田修"],
    rating: 8.1,
    views: 690000,
    updatedAt: "2026-06-25",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Summer%20youth%20romance%20film%20poster%2C%20two%20teenagers%20standing%20on%20a%20rural%20train%20crossing%20with%20windmills%20in%20the%20background%2C%20lush%20green%20rice%20fields%2C%20bright%20hazy%20afternoon%20sunlight%2C%20clear%20pale%20sky%2C%20nostalgic%20Japanese%20summer%20aesthetic%2C%20gentle%20film%20photography%20look&width=600&height=840&seq=mv-summer-of-cicadas&orientation=portrait",
    summary:
      "那个夏天，镇上唯一一条铁路即将停运。两个准备离开的少年，用一本借来的旧相机，把所有不想忘掉的东西都拍了一遍。",
  },
  {
    id: "iron-chef-street",
    title: "街角食堂第二季",
    type: "tv",
    genres: ["剧情", "治愈"],
    region: "国产",
    year: 2026,
    duration: "单集45分钟",
    episodes: "更新至 16 集 / 共 24 集",
    director: "许青禾",
    cast: ["程致远", "方念", "高宇辰", "丁小满"],
    rating: 9.0,
    views: 3420000,
    updatedAt: "2026-10-16",
    status: "更新至 16 集",
    cover: "https://readdy.ai/api/search-image?query=Warm%20healing%20TV%20series%20poster%2C%20a%20small%20neighborhood%20kitchen%20with%20a%20steaming%20pot%2C%20an%20aproned%20cook%20smiling%20by%20a%20window%2C%20soft%20honey%20and%20sage%20green%20palette%2C%20morning%20light%20through%20lace%20curtains%2C%20hanging%20dried%20herbs%20and%20ceramic%20bowls%2C%20cozy%20documentary%20style%20cinematic%20composition&width=600&height=840&seq=tv-street-canteen&orientation=portrait",
    summary:
      "老城区巷口的街角食堂重新开门，新老板是个不会寒暄的年轻人。他用一道道家常菜，慢慢接住了整条街的喜怒哀乐，也接住了自己没说完的过去。",
  },
  {
    id: "silent-witness-code",
    title: "沉默的证词",
    type: "tv",
    genres: ["悬疑", "犯罪"],
    region: "国产",
    year: 2026,
    duration: "单集48分钟",
    episodes: "全 32 集",
    director: "陆知远",
    cast: ["段青野", "郗宁", "查明", "岳川"],
    rating: 9.2,
    views: 4780000,
    updatedAt: "2026-10-17",
    status: "全 32 集",
    cover: "https://readdy.ai/api/search-image?query=Crime%20mystery%20series%20poster%2C%20a%20forensic%20investigator%20examining%20evidence%20under%20a%20single%20desk%20lamp%20in%20a%20dark%20office%2C%20case%20files%20and%20photographs%20spread%20across%20the%20table%2C%20cold%20navy%20shadows%20with%20amber%20lamp%20glow%2C%20rain%20streaked%20window%20in%20background%2C%20tense%20premium%20cinematic%20look&width=600&height=840&seq=tv-silent-witness&orientation=portrait",
    summary:
      "一名因说真话而被停职的检察官，和一位从不开口的目击证人，共同追查一起被定性为意外的旧案。卷宗里每一页都是别人的名字，只有最后一页没有署名。",
  },
  {
    id: "city-of-lights",
    title: "霓虹之城",
    type: "tv",
    genres: ["都市", "爱情"],
    region: "国产",
    year: 2025,
    duration: "单集42分钟",
    episodes: "全 28 集",
    director: "韩知许",
    cast: ["陆嘉禾", "沈之遥", "何斯远", "温凝"],
    rating: 8.4,
    views: 3960000,
    updatedAt: "2026-10-10",
    status: "全 28 集",
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20series%20poster%2C%20two%20people%20on%20a%20rooftop%20overlooking%20a%20glowing%20city%20skyline%20at%20night%2C%20warm%20amber%20window%20lights%20and%20cool%20indigo%20sky%2C%20reflective%20glass%20architecture%2C%20rain%20gloss%20on%20the%20parapet%2C%20sophisticated%20cinematic%20editorial%20poster&width=600&height=840&seq=tv-city-of-lights&orientation=portrait",
    summary:
      "两个在同一栋写字楼里上夜班的人，三年里从未见过面，却每天在电梯间的便签上留言。当公司裁员的消息传来，他们必须在最后一班电梯前决定见不见。",
  },
  {
    id: "old-street-heroes",
    title: "老巷英雄",
    type: "tv",
    genres: ["喜剧", "家庭"],
    region: "国产",
    year: 2025,
    duration: "单集40分钟",
    episodes: "全 26 集",
    director: "史大鹏",
    cast: ["刘守业", "钱多福", "孙桂兰", "赵小虎"],
    rating: 8.6,
    views: 2150000,
    updatedAt: "2026-09-22",
    status: "全 26 集",
    cover: "https://readdy.ai/api/search-image?query=Heartwarming%20family%20comedy%20series%20poster%2C%20a%20group%20of%20cheerful%20elderly%20neighbors%20playing%20cards%20outside%20an%20old%20brick%20alley%20teahouse%2C%20bicycles%20and%20potted%20plants%2C%20warm%20golden%20late%20afternoon%20light%2C%20vintage%20Chinese%20neighborhood%20charm%2C%20friendly%20cinematic%20composition&width=600&height=840&seq=tv-old-street-heroes&orientation=portrait",
    summary:
      "老巷要装电梯了，五个一辈子没出过巷子的老人临时组了个“业主委员会”。吵了二十六集，最后发现大家真正想要的其实是同一件事。",
  },
  {
    id: "quantum-tide-tv",
    title: "量子潮汐",
    type: "tv",
    genres: ["科幻", "悬疑"],
    region: "欧美",
    year: 2026,
    duration: "单集52分钟",
    episodes: "更新至 8 集 / 共 10 集",
    director: "Adrian Cole",
    cast: ["Nathan Ross", "Ivy Mercer", "Owen Blake", "Sofia Renn"],
    rating: 9.3,
    views: 5210000,
    updatedAt: "2026-10-16",
    status: "更新至 8 集",
    cover: "https://readdy.ai/api/search-image?query=High%20concept%20sci-fi%20series%20poster%2C%20a%20researcher%20standing%20in%20front%20of%20a%20massive%20glowing%20holographic%20data%20spiral%2C%20deep%20navy%20laboratory%20environment%2C%20cyan%20and%20amber%20hologram%20edges%2C%20floating%20geometric%20particles%2C%20sleek%20futuristic%20premium%20key%20art%20with%20dramatic%20lighting&width=600&height=840&seq=tv-quantum-tide&orientation=portrait",
    summary:
      "一支物理团队在实验中发现，每一次观测都让世界分叉一次。而现在，他们需要把分叉的十种结局，压缩回同一个明天。",
  },
  {
    id: "the-ninth-floor",
    title: "第九层",
    type: "tv",
    genres: ["悬疑", "惊悚"],
    region: "日韩",
    year: 2025,
    duration: "单集50分钟",
    episodes: "全 12 集",
    director: "金泰浩",
    cast: ["申宇镇", "尹书妍", "白成焕", "全美罗"],
    rating: 8.9,
    views: 2890000,
    updatedAt: "2026-09-30",
    status: "全 12 集",
    cover: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20series%20poster%2C%20a%20long%20apartment%20corridor%20with%20flickering%20fluorescent%20lights%20and%20a%20door%20numbered%20nine%2C%20cold%20grey%20green%20shadow%20palette%2C%20one%20warm%20light%20spilling%20from%20under%20the%20door%2C%20peeling%20wallpaper%20texture%2C%20ominous%20cinematic%20one%20point%20perspective&width=600&height=840&seq=tv-ninth-floor&orientation=portrait",
    summary:
      "一栋公寓楼的第九层在图纸上不存在，却总有住户按到那一层的按钮。物业新来的管理员决定亲自上去看看。",
  },
  {
    id: "healing-north-island",
    title: "北岛疗愈计划",
    type: "tv",
    genres: ["治愈", "剧情"],
    region: "日韩",
    year: 2026,
    duration: "单集46分钟",
    episodes: "更新至 10 集 / 共 12 集",
    director: "森田凉",
    cast: ["水野遥", "森川凛", "冈田新", "小野梓"],
    rating: 8.8,
    views: 1760000,
    updatedAt: "2026-10-13",
    status: "更新至 10 集",
    cover: "https://readdy.ai/api/search-image?query=Gentle%20healing%20drama%20series%20poster%2C%20a%20small%20wooden%20house%20overlooking%20a%20northern%20island%20coast%20with%20lavender%20fields%2C%20muted%20sage%20and%20soft%20lilac%20tones%2C%20drifting%20clouds%20and%20distant%20sea%2C%20a%20woman%20carrying%20a%20basket%20on%20a%20stone%20path%2C%20calm%20minimal%20cinematic%20aesthetic&width=600&height=840&seq=tv-healing-north-island&orientation=portrait",
    summary:
      "一个被工作耗尽的城市女孩，被派到北方小岛上的诊所代班三个月。岛上的病人不多，但她每一集都要重新学着慢慢生活。",
  },
  {
    id: "harbor-unit",
    title: "港湾救援队",
    type: "tv",
    genres: ["动作", "剧情"],
    region: "欧美",
    year: 2025,
    duration: "单集44分钟",
    episodes: "全 20 集",
    director: "Marcus Hale",
    cast: ["Dylan Fox", "Eva Moran", "Colin Ward", "Rita Shaw"],
    rating: 8.2,
    views: 1340000,
    updatedAt: "2026-08-18",
    status: "全 20 集",
    cover: "https://readdy.ai/api/search-image?query=Action%20drama%20series%20poster%2C%20a%20coast%20guard%20rescue%20boat%20cutting%20through%20rough%20grey%20waves%20at%20dusk%2C%20orange%20flare%20light%20against%20storm%20clouds%2C%20crew%20in%20heavy%20jackets%20on%20deck%2C%20cold%20steel%20blue%20palette%20with%20warm%20safety%20orange%2C%20cinematic%20action%20composition&width=600&height=840&seq=tv-harbor-unit&orientation=portrait",
    summary:
      "港湾救援队全年三百六十五天待命，救过落水的船夫，也救过被浪卷走的婚礼。他们保护着这片海，却没人告诉过他们该怎么面对自己没救回来的那个夜晚。",
  },
  {
    id: "campus-daybreak",
    title: "校园破晓",
    type: "tv",
    genres: ["青春", "校园"],
    region: "国产",
    year: 2024,
    duration: "单集40分钟",
    episodes: "全 24 集",
    director: "许青禾",
    cast: ["何星洲", "姜小北", "阮时", "章一粟"],
    rating: 8.0,
    views: 1980000,
    updatedAt: "2026-07-28",
    status: "全 24 集",
    cover: "https://readdy.ai/api/search-image?query=Youth%20campus%20drama%20series%20poster%2C%20students%20cycling%20down%20a%20tree%20lined%20university%20avenue%20at%20early%20morning%2C%20warm%20peach%20sunrise%20light%20through%20green%20leaves%2C%20school%20building%20facade%20in%20background%2C%20fresh%20bright%20hopeful%20mood%2C%20clean%20cinematic%20composition&width=600&height=840&seq=tv-campus-daybreak&orientation=portrait",
    summary:
      "大一新生的社团招新周，五个不同专业的人因为一间借来的旧教室组成了“破晓社”。他们的第一次活动，是替全校最后一名夜班宿管办一场退休会。",
  },
  {
    id: "little-town-chefs",
    title: "小镇食光",
    type: "tv",
    genres: ["家庭", "美食"],
    region: "国产",
    year: 2025,
    duration: "单集38分钟",
    episodes: "全 18 集",
    director: "何晚晴",
    cast: ["严冬", "白雨桐", "查老三", "周小禾"],
    rating: 8.5,
    views: 1120000,
    updatedAt: "2026-06-14",
    status: "全 18 集",
    cover: "https://readdy.ai/api/search-image?query=Warm%20family%20food%20series%20poster%2C%20a%20rural%20town%20kitchen%20with%20a%20grandmother%20and%20granddaughter%20kneading%20dough%20side%20by%20side%2C%20wooden%20counter%20with%20vegetables%20and%20clay%20jars%2C%20golden%20afternoon%20light%20through%20a%20rustic%20window%2C%20cozy%20nostalgic%20cinematic%20tone&width=600&height=840&seq=tv-little-town-chefs&orientation=portrait",
    summary:
      "小镇上的老饭馆只剩一位掌勺的奶奶和一个不会做饭的孙女。为了不让灶台冷掉，她们决定把整条街客人的拿手菜都学一遍。",
  },
  {
    id: "echo-of-walls",
    title: "回声之墙",
    type: "tv",
    genres: ["悬疑", "剧情"],
    region: "欧美",
    year: 2026,
    duration: "单集48分钟",
    episodes: "更新至 6 集 / 共 8 集",
    director: "Clara Lindqvist",
    cast: ["Ruth Vale", "Peter Lund", "Jonas Berg", "Nadia Kerr"],
    rating: 8.7,
    views: 1560000,
    updatedAt: "2026-10-11",
    status: "更新至 6 集",
    cover: "https://readdy.ai/api/search-image?query=Moody%20mystery%20drama%20series%20poster%2C%20an%20old%20stone%20house%20wall%20with%20faded%20frescoes%20lit%20by%20a%20single%20window%20beam%2C%20dust%20particles%20in%20the%20air%2C%20muted%20slate%20green%20and%20pale%20ochre%20palette%2C%20faint%20human%20silhouette%20painted%20on%20the%20plaster%2C%20artful%20cinematic%20composition&width=600&height=840&seq=tv-echo-of-walls&orientation=portrait",
    summary:
      "一位修复古壁画的画师，在剥落的灰泥下发现了自己童年住过的房间。墙上的每一层颜料，都对应着一件她以为自己早已忘记的事。",
  },
  {
    id: "neon-route",
    title: "霓虹线路",
    type: "variety",
    genres: ["旅行", "音乐"],
    region: "国产",
    year: 2026,
    duration: "单集75分钟",
    episodes: "更新至 9 期 / 共 12 期",
    director: "周砚",
    cast: ["常驻主创：阿岚乐队", "黄一帆", "温月", "祁野"],
    rating: 8.6,
    views: 2380000,
    updatedAt: "2026-10-16",
    status: "更新至 第9期",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20music%20travel%20variety%20show%20poster%2C%20a%20band%20performing%20on%20a%20night%20rooftop%20stage%20with%20city%20skyline%20behind%2C%20neon%20signs%20in%20warm%20orange%20and%20yellow%2C%20confetti%20and%20stage%20haze%2C%20energetic%20festival%20atmosphere%2C%20rich%20cinematic%20color%20grading&width=600&height=840&seq=vr-neon-route&orientation=portrait",
    summary:
      "六位音乐人带着一辆改装巡演车，沿着十二条城市线路边演出边旅行。每到一站，他们要和当地的素人乐手合作一首只属于那晚的歌。",
  },
  {
    id: "kitchen-battle",
    title: "厨房对战局",
    type: "variety",
    genres: ["美食", "竞技"],
    region: "国产",
    year: 2026,
    duration: "单集68分钟",
    episodes: "更新至 11 期 / 共 14 期",
    director: "梁大申",
    cast: ["主持：费骁", "评审：老陶", "评审：苏甜", "评审：宁师傅"],
    rating: 8.3,
    views: 2070000,
    updatedAt: "2026-10-15",
    status: "更新至 第11期",
    cover: "https://readdy.ai/api/search-image?query=Competitive%20cooking%20show%20poster%2C%20two%20chefs%20in%20white%20jackets%20facing%20off%20across%20a%20dark%20stainless%20steel%20kitchen%20island%2C%20flames%20and%20steam%2C%20warm%20orange%20studio%20spotlights%20against%20deep%20navy%20backdrop%2C%20dramatic%20high%20contrast%20food%20closeups%2C%20premium%20cinematic%20poster&width=600&height=840&seq=vr-kitchen-battle&orientation=portrait",
    summary:
      "每期三位素人厨师在九十分钟内完成同一道题的三种解法。本期关键词只有两个字：家常。当最后一道菜端上桌，评审席上有人没忍住红了眼。",
  },
  {
    id: "island-quest",
    title: "荒岛计划",
    type: "variety",
    genres: ["户外", "竞技"],
    region: "国产",
    year: 2025,
    duration: "单集80分钟",
    episodes: "全 12 期",
    director: "程野",
    cast: ["主创：江驰", "主创：鹿遥", "主创：大丁", "主创：陈拾一"],
    rating: 8.5,
    views: 2640000,
    updatedAt: "2026-09-24",
    status: "全 12 期",
    cover: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20reality%20show%20poster%2C%20four%20travelers%20with%20backpacks%20walking%20along%20a%20wild%20rocky%20island%20shoreline%2C%20turquoise%20sea%20and%20dramatic%20clouds%2C%20warm%20sun%20flare%2C%20driftwood%20and%20tall%20grass%2C%20wide%20expansive%20cinematic%20landscape%20composition&width=600&height=840&seq=vr-island-quest&orientation=portrait",
    summary:
      "八位嘉宾被送到一座没有信号的岛上，只带一盏灯和一本指南。他们要自己找食物、盖住所、定规则，并在十二天后回答一个问题：还想回去吗？",
  },
  {
    id: "sing-your-heart",
    title: "唱给你听",
    type: "variety",
    genres: ["音乐", "情感"],
    region: "国产",
    year: 2026,
    duration: "单集62分钟",
    episodes: "更新至 7 期 / 共 10 期",
    director: "关月",
    cast: ["主唱：许弦", "主唱：南岸", "主唱：白露", "主持：夏予"],
    rating: 8.9,
    views: 1890000,
    updatedAt: "2026-10-14",
    status: "更新至 第7期",
    cover: "https://readdy.ai/api/search-image?query=Intimate%20music%20variety%20show%20poster%2C%20a%20singer%20at%20a%20vintage%20microphone%20on%20a%20small%20warmly%20lit%20stage%2C%20single%20amber%20spotlight%20in%20dark%20room%2C%20soft%20haze%2C%20audience%20silhouettes%20in%20foreground%2C%20emotional%20elegant%20cinematic%20portrait%2C%20rich%20texture&width=600&height=840&seq=vr-sing-your-heart&orientation=portrait",
    summary:
      "每位歌手要为一位素人的真实故事写一首歌，并在故事发生的现场唱给他听。这一期，一位开了四十年公交的司机收到了一首关于末班车的歌。",
  },
  {
    id: "watch-the-night",
    title: "陪你看夜",
    type: "variety",
    genres: ["人文", "纪实"],
    region: "日韩",
    year: 2025,
    duration: "单集55分钟",
    episodes: "全 10 期",
    director: "森川凛",
    cast: ["主持：水野遥", "嘉宾：冈田新", "嘉宾：井上葵", "嘉宾：原田律"],
    rating: 9.1,
    views: 1520000,
    updatedAt: "2026-08-12",
    status: "全 10 期",
    cover: "https://readdy.ai/api/search-image?query=Quiet%20documentary%20series%20poster%2C%20a%20late%20night%20city%20overpass%20with%20a%20person%20sitting%20on%20the%20railing%20looking%20at%20distant%20apartment%20windows%2C%20deep%20indigo%20sky%20with%20soft%20warm%20window%20glow%2C%20reflective%20wet%20pavement%2C%20contemplative%20slow%20cinema%20aesthetic%2C%20gentle%20film%20grain&width=600&height=840&seq=vr-watch-the-night&orientation=portrait",
    summary:
      "摄制组在城市里寻找那些整夜不睡的人：便利店店长、夜班护士、凌晨的配音演员。他们安静地坐下来，陪对方看一段夜，再听对方讲一段人生。",
  },
  {
    id: "brain-gym",
    title: "脑力运动会",
    type: "variety",
    genres: ["游戏", "喜剧"],
    region: "国产",
    year: 2026,
    duration: "单集70分钟",
    episodes: "更新至 5 期 / 共 12 期",
    director: "费骁",
    cast: ["主持：费骁", "队长：迟野", "队长：小满", "队长：方程"],
    rating: 7.8,
    views: 1230000,
    updatedAt: "2026-10-09",
    status: "更新至 第5期",
    cover: "https://readdy.ai/api/search-image?query=Playful%20game%20show%20poster%2C%20colorful%20studio%20set%20with%20oversized%20wooden%20puzzle%20blocks%20and%20giant%20number%20cards%2C%20bright%20mustard%20yellow%20and%20warm%20orange%20panels%2C%20deep%20navy%20floor%20with%20reflective%20finish%2C%20dynamic%20fun%20energetic%20composition%2C%20polished%20broadcast%20design&width=600&height=840&seq=vr-brain-gym&orientation=portrait",
    summary:
      "三支队伍每期挑战四个脑力关卡，题目简单却总能难倒在场的所有人。第三期最后的记忆题，让主持人自己先输给了观众席上的一位小学生。",
  },
  {
    id: "farmhouse-weekend",
    title: "周末去种田",
    type: "variety",
    genres: ["生活", "治愈"],
    region: "国产",
    year: 2025,
    duration: "单集58分钟",
    episodes: "全 14 期",
    director: "丁小满",
    cast: ["常驻：阿慢", "常驻：老雷", "常驻：糖糖", "常驻：小禾"],
    rating: 8.4,
    views: 987000,
    updatedAt: "2026-07-16",
    status: "全 14 期",
    cover: "https://readdy.ai/api/search-image?query=Slow%20living%20farm%20variety%20show%20poster%2C%20a%20rustic%20vegetable%20field%20at%20golden%20hour%20with%20four%20people%20harvesting%20baskets%2C%20wooden%20fence%20and%20distant%20mountains%2C%20earthy%20sage%20green%20and%20warm%20ochre%20tones%2C%20peaceful%20rural%20atmosphere%2C%20soft%20natural%20light&width=600&height=840&seq=vr-farmhouse-weekend&orientation=portrait",
    summary:
      "四个城里人每个周末都来郊区借种一块地，从播种到收割，也顺便把一周的坏心情埋进土里。这期他们终于等到了第一茬西红柿，却先被暴雨浇了个透。",
  },
  {
    id: "paper-crane-news",
    title: "纸鹤来信",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "国产",
    year: 2026,
    duration: "110分钟",
    episodes: "完整版",
    director: "苏晚",
    cast: ["姜素", "关山月", "黄之衡", "范小南"],
    rating: 8.8,
    views: 810000,
    updatedAt: "2026-10-02",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Emotional%20family%20drama%20poster%2C%20a%20small%20desk%20with%20many%20folded%20paper%20cranes%20and%20handwritten%20letters%2C%20soft%20morning%20light%20through%20a%20lace%20curtain%2C%20warm%20cream%20and%20muted%20sage%20palette%2C%20shallow%20depth%20of%20field%2C%20tender%20nostalgic%20cinematic%20still&width=600&height=840&seq=mv-paper-crane-news&orientation=portrait",
    summary:
      "母亲去世后，女儿在旧衣柜里发现了三百二十七只纸鹤，每只里面都写着一句话。她决定按照上面写的路，一个一个去走一遍。",
  },
  {
    id: "silver-route",
    title: "银线列车",
    type: "movie",
    genres: ["冒险", "剧情"],
    region: "欧美",
    year: 2024,
    duration: "136分钟",
    episodes: "完整版",
    director: "Adrian Cole",
    cast: ["Owen Blake", "Sofia Renn", "Nathan Ross", "Eva Moran"],
    rating: 8.4,
    views: 1020000,
    updatedAt: "2026-06-05",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Adventure%20drama%20poster%2C%20a%20vintage%20silver%20passenger%20train%20crossing%20a%20tall%20trestle%20bridge%20through%20autumn%20mountains%2C%20warm%20amber%20and%20slate%20blue%20color%20palette%2C%20mist%20in%20the%20valley%2C%20tiny%20figure%20leaning%20from%20a%20window%2C%20sweeping%20cinematic%20landscape%20composition&width=600&height=840&seq=mv-silver-route&orientation=portrait",
    summary:
      "一条即将停运的支线列车，载着一车厢各怀心事的乘客走向终点站。列车长开了三十年这条线，这一次他终于决定在车上讲完那个故事。",
  },
  {
    id: "broken-mirror",
    title: "碎镜",
    type: "movie",
    genres: ["惊悚", "心理"],
    region: "日韩",
    year: 2026,
    duration: "115分钟",
    episodes: "完整版",
    director: "尹书妍",
    cast: ["全美罗", "申宇镇", "白成焕", "徐允"],
    rating: 8.2,
    views: 1360000,
    updatedAt: "2026-10-11",
    status: "独家上线",
    cover: "https://readdy.ai/api/search-image?query=Psychological%20thriller%20poster%2C%20a%20cracked%20antique%20mirror%20in%20a%20dim%20room%20with%20a%20woman%20reflection%20slightly%20out%20of%20sync%2C%20cold%20desaturated%20green%20grey%20palette%20with%20a%20single%20warm%20candle%20flame%2C%20fractured%20glass%20details%2C%20unsettling%20elegant%20cinematic%20composition&width=600&height=840&seq=mv-broken-mirror&orientation=portrait",
    summary:
      "心理医生接手一位自称“镜子里的人多了一个”的病人。随着治疗推进，她开始怀疑，诊室墙上那面镜子映出的，究竟是谁的房间。",
  },
  {
    id: "open-air-cinema",
    title: "露天电影院",
    type: "movie",
    genres: ["剧情", "爱情"],
    region: "国产",
    year: 2025,
    duration: "109分钟",
    episodes: "完整版",
    director: "何晚晴",
    cast: ["吕知行", "沈星野", "陈小满", "吴岸"],
    rating: 8.6,
    views: 745000,
    updatedAt: "2026-05-28",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20romance%20poster%2C%20an%20open%20air%20small%20town%20cinema%20screen%20glowing%20under%20a%20starrier%20night%20sky%2C%20rows%20of%20wooden%20benches%20with%20warm%20silhouettes%2C%20amber%20projector%20beam%20cutting%20through%20soft%20haze%2C%20deep%20blue%20evening%20tones%2C%20tender%20cinematic%20mood&width=600&height=840&seq=mv-open-air-cinema&orientation=portrait",
    summary:
      "镇上唯一的露天电影院要拆了，放映员决定免费放映最后三十天。每晚的观众越来越少，直到有个女孩每晚都坐在同一张长椅上，等一部从未放映的电影。",
  },
  {
    id: "mission-whale",
    title: "深海追鲸",
    type: "movie",
    genres: ["冒险", "自然"],
    region: "欧美",
    year: 2026,
    duration: "98分钟",
    episodes: "完整版",
    director: "Elias Vance",
    cast: ["Leah Sanders", "Ivan Petrov", "Marcus Hale", "Nora Quinn"],
    rating: 8.7,
    views: 1190000,
    updatedAt: "2026-10-03",
    status: "4K 修复",
    cover: "https://readdy.ai/api/search-image?query=Ocean%20adventure%20documentary%20poster%2C%20a%20humpback%20whale%20breaching%20beside%20a%20small%20research%20boat%20under%20a%20pale%20misty%20sunrise%20sky%2C%20deep%20teal%20water%20and%20warm%20peach%20light%20on%20the%20whale%20skin%2C%20spray%20droplets%20in%20air%2C%20awe%20inspiring%20cinematic%20wide%20composition&width=600&height=840&seq=mv-mission-whale&orientation=portrait",
    summary:
      "一支海洋研究队追随一头被标记的座头鲸，横跨两万公里。他们要确认的不是它的路线，而是它为什么每年都要绕远去同一个没有的海湾。",
  },
  {
    id: "twenty-four-hours",
    title: "二十四小时便利店",
    type: "tv",
    genres: ["剧情", "都市"],
    region: "国产",
    year: 2026,
    duration: "单集42分钟",
    episodes: "更新至 14 集 / 共 20 集",
    director: "韩知许",
    cast: ["邵野", "孟夏", "宋清简", "谢南"],
    rating: 8.8,
    views: 2290000,
    updatedAt: "2026-10-17",
    status: "更新至 14 集",
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20series%20poster%2C%20a%20bright%20convenience%20store%20interior%20at%20midnight%20seen%20from%20the%20street%2C%20glowing%20warm%20window%20against%20dark%20rainy%20street%2C%20neon%20sign%20reflections%20on%20wet%20asphalt%2C%20a%20clerk%20standing%20by%20the%20counter%2C%20cinematic%20urban%20night%20aesthetic&width=600&height=840&seq=tv-24-hours-store&orientation=portrait",
    summary:
      "一家二十四小时便利店，是这座城市最小的公共空间。收银台前的十四集故事里，有人来这里买东西，有人来这里躲避，也有人只是想让灯亮着。",
  },
  {
    id: "restart-northbound",
    title: "向北重来",
    type: "tv",
    genres: ["都市", "成长"],
    region: "国产",
    year: 2025,
    duration: "单集45分钟",
    episodes: "全 30 集",
    director: "罗定山",
    cast: ["崔亦然", "冯子衿", "顾遥", "章野"],
    rating: 8.3,
    views: 1720000,
    updatedAt: "2026-09-08",
    status: "全 30 集",
    cover: "https://readdy.ai/api/search-image?query=Inspiring%20urban%20drama%20poster%2C%20a%20young%20woman%20standing%20on%20a%20northern%20city%20overpass%20with%20snow%20falling%2C%20warm%20apartment%20lights%20and%20cold%20blue%20evening%20sky%2C%20woolen%20coat%20and%20a%20suitcase%2C%20quiet%20determined%20mood%2C%20cinematic%20winter%20composition&width=600&height=840&seq=tv-restart-northbound&orientation=portrait",
    summary:
      "三十五岁被裁员的她，决定把老家的房子改成咖啡馆。母亲不同意，父亲不出声，只有隔壁院子里那棵树一直没有变过，还站在那里。",
  },
  {
    id: "the-writer-room",
    title: "编剧室风波",
    type: "tv",
    genres: ["喜剧", "职场"],
    region: "日韩",
    year: 2026,
    duration: "单集44分钟",
    episodes: "更新至 12 集 / 共 16 集",
    director: "佐藤和也",
    cast: ["中村丈", "宫崎铃", "小林悠真", "水野遥"],
    rating: 8.1,
    views: 1450000,
    updatedAt: "2026-10-13",
    status: "更新至 12 集",
    cover: "https://readdy.ai/api/search-image?query=Workplace%20comedy%20series%20poster%2C%20a%20cluttered%20writers%20room%20filled%20with%20whiteboards%20covered%20in%20story%20notes%2C%20stacked%20scripts%20and%20coffee%20cups%2C%20warm%20fluorescent%20and%20desk%20lamp%20lighting%2C%20late%20night%20window%20with%20city%20glow%2C%20chaotic%20charming%20cinematic%20composition&width=600&height=840&seq=tv-writer-room&orientation=portrait",
    summary:
      "一部剧的剧本改到第十七版，编剧室的四个人已经谁都不记得第一版写了什么。而制片人这次带来的要求是：把主角的性别换一下，明天开机。",
  },
  {
    id: "cloud-kitchen",
    title: "云端厨房",
    type: "variety",
    genres: ["美食", "生活"],
    region: "欧美",
    year: 2026,
    duration: "单集50分钟",
    episodes: "更新至 6 期 / 共 10 期",
    director: "Nora Quinn",
    cast: ["主持：Colin Ward", "嘉宾：Rita Shaw", "嘉宾：Dylan Fox", "嘉宾：Eva Moran"],
    rating: 8.5,
    views: 860000,
    updatedAt: "2026-10-07",
    status: "更新至 第6期",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20cooking%20show%20poster%2C%20a%20bright%20minimal%20kitchen%20with%20marble%20counter%2C%20hands%20plating%20a%20colorful%20seasonal%20dish%2C%20soft%20daylight%20through%20large%20windows%20overlooking%20mountains%2C%20warm%20cream%20and%20sage%20palette%2C%20refined%20editorial%20food%20photography&width=600&height=840&seq=vr-cloud-kitchen&orientation=portrait",
    summary:
      "每期请一位来自不同城市的素人厨师，在自己的厨房里做一道最拿手的菜。没有评委，没有分数，只有一段关于这道菜为什么重要的时间。",
  },
  {
    id: "quiet-night-radio",
    title: "深夜电台",
    type: "variety",
    genres: ["情感", "音乐"],
    region: "国产",
    year: 2025,
    duration: "单集48分钟",
    episodes: "全 16 期",
    director: "关月",
    cast: ["主持：南岸", "主持：许弦", "嘉宾：白露", "嘉宾：温月"],
    rating: 8.9,
    views: 910000,
    updatedAt: "2026-06-30",
    status: "全 16 期",
    cover: "https://readdy.ai/api/search-image?query=Late%20night%20radio%20show%20poster%2C%20a%20vintage%20broadcast%20studio%20with%20a%20glowing%20on%20air%20sign%2C%20microphone%20and%20headphones%20on%20a%20wooden%20desk%2C%20deep%20navy%20room%20with%20warm%20amber%20lamp%20glow%2C%20rain%20streaks%20on%20the%20window%2C%20intimate%20nostalgic%20cinematic%20still&width=600&height=840&seq=vr-quiet-night-radio&orientation=portrait",
    summary:
      "一档只播出十六期的深夜电台，每周读一封听众来信。最后一期，节目组收到了同一封信的两个版本，字迹相同，内容却完全相反。",
  },
  {
    id: "three-generations",
    title: "三代同堂",
    type: "tv",
    genres: ["家庭", "喜剧"],
    region: "国产",
    year: 2024,
    duration: "单集40分钟",
    episodes: "全 36 集",
    director: "梁大申",
    cast: ["刘守业", "周小禾", "钱多福", "丁小满"],
    rating: 8.4,
    views: 2410000,
    updatedAt: "2026-05-12",
    status: "全 36 集",
    cover: "https://readdy.ai/api/search-image?query=Family%20comedy%20series%20poster%2C%20three%20generations%20of%20a%20family%20gathered%20around%20a%20dinner%20table%20in%20a%20warm%20traditional%20apartment%2C%20steaming%20dishes%20and%20lantern%20light%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20lively%20affectionate%20atmosphere%2C%20cinematic%20poster%20composition&width=600&height=840&seq=tv-three-generations&orientation=portrait",
    summary:
      "爷爷坚持每天早起做饭，妈妈坚持每顿量化营养，女儿坚持只吃外卖。三个人在一张饭桌上吵了三十六集，也一起吃了三十六集。",
  },
  {
    id: "wild-silence",
    title: "荒野静默",
    type: "movie",
    genres: ["剧情", "户外"],
    region: "欧美",
    year: 2025,
    duration: "121分钟",
    episodes: "完整版",
    director: "Dmitri Sokolov",
    cast: ["Ilona Marsh", "Tobias Reed", "Viktor Lang", "Mia Novak"],
    rating: 8.6,
    views: 940000,
    updatedAt: "2026-04-22",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Solitary%20wilderness%20drama%20poster%2C%20a%20lone%20hiker%20with%20a%20pack%20standing%20on%20a%20high%20ridge%20above%20a%20vast%20misty%20forest%20valley%2C%20muted%20sage%20green%20and%20soft%20amber%20morning%20light%2C%20layered%20mountain%20silhouettes%2C%20quiet%20contemplative%20cinematic%20wide%20shot&width=600&height=840&seq=mv-wild-silence&orientation=portrait",
    summary:
      "一个人，一条没有标注的路线，和十四天的补给。她要走到山谷尽头那座早已废弃的观测站，只为亲手关掉父亲留下的那台机器。",
  },
  {
    id: "match-point-summer",
    title: "夏日赛点",
    type: "movie",
    genres: ["运动", "青春"],
    region: "日韩",
    year: 2026,
    duration: "113分钟",
    episodes: "完整版",
    director: "李泰成",
    cast: ["郑在民", "崔恩书", "朴秀妍", "徐允"],
    rating: 8.0,
    views: 780000,
    updatedAt: "2026-10-01",
    status: "高清正片",
    cover: "https://readdy.ai/api/search-image?query=Sports%20teen%20drama%20poster%2C%20a%20young%20tennis%20player%20mid%20serve%20on%20a%20clay%20court%2C%20golden%20sunset%20backlight%20and%20long%20shadow%2C%20warm%20terracotta%20court%20with%20deep%20green%20surroundings%2C%20sweat%20and%20dust%20particles%20in%20the%20air%2C%20dynamic%20cinematic%20composition&width=600&height=840&seq=mv-match-point-summer&orientation=portrait",
    summary:
      "小镇上唯一一块网球场的最后一场比赛，是两个从小一起练球的朋友之间的对决。赢的人可以去省队，输的人留下来。他们都知道这场球该怎么打，也都不打算那样打。",
  },
];

export const featuredIds = [
  "seventh-tide",
  "silent-witness-code",
  "quantum-tide-tv",
  "fog-city-rain",
  "deep-sea-signal",
];

export const getMediaById = (id: string): Media | undefined =>
  mediaList.find((item) => item.id === id);

export const getRelatedMedia = (media: Media, limit = 6): Media[] => {
  return mediaList
    .filter((item) => item.id !== media.id)
    .map((item) => {
      let score = 0;
      if (item.type === media.type) score += 3;
      if (item.region === media.region) score += 2;
      score += item.genres.filter((g) => media.genres.includes(g)).length * 2;
      return { item, score, rating: item.rating };
    })
    .sort((a, b) => b.score - a.score || b.rating - a.rating)
    .slice(0, limit)
    .map((entry) => entry.item);
};

export const searchMedia = (keyword: string): Media[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return mediaList.filter((item) =>
    [item.title, item.type, typeLabel[item.type], item.region, item.summary, ...item.genres, ...item.cast, item.director]
      .join(" ")
      .toLowerCase()
      .includes(kw)
  );
};

export const regions = ["国产", "欧美", "日韩"];
export const years = ["2026", "2025", "2024"];
export const genreOptions: Record<MediaType, string[]> = {
  movie: ["动作", "爱情", "喜剧", "悬疑", "剧情", "科幻", "青春", "冒险", "犯罪", "治愈", "历史", "惊悚", "美食", "心理", "家庭", "运动", "户外", "自然"],
  tv: ["悬疑", "剧情", "都市", "家庭", "科幻", "青春", "治愈", "犯罪", "喜剧", "职场", "成长", "惊悚", "校园", "美食", "动作"],
  variety: ["旅行", "音乐", "美食", "竞技", "户外", "情感", "人文", "纪实", "游戏", "喜剧", "生活", "治愈"],
};